import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountStore } from '../store';
import { isNull } from 'lodash';
import { Challenge } from '../store/models';

@Injectable()
export class UnusualActivityGuard implements CanActivate {
  constructor(private _router: Router, private _accountStore: AccountStore) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this._accountStore
      .getChallenge()
      .pipe(
        map(
          (challenge: Challenge) =>
            !isNull(challenge) || this._router.parseUrl('/login')
        )
      );
  }
}
